export default "__VITE_ASSET__Dn0GP_ye__"